// ActionButtons.tsx
import React from "react";
import { Button } from "./button";

interface ActionButtonsProps {
  primaryText: string;
  secondaryText: string;
  onPrimaryClick?: () => void;
  onSecondaryClick?: () => void;
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  primaryText,
  secondaryText,
  onPrimaryClick,
  onSecondaryClick,
}) => {
  return (
    <div className="flex justify-between items-center w-full pt-4 pb-4">
      <Button type="secondary" onClick={onSecondaryClick}>
        {secondaryText}
      </Button>
      {primaryText && (
        <Button type="primary" onClick={onPrimaryClick}>
          {primaryText}
        </Button>
      )}
    </div>
  );
};
